let config;

if (window.location.hostname === "localhost") {
  config = require(`./binapsis/local.config.js`);
}

if (window.location.hostname === "aristas-adc75de38188.herokuapp.com") {
  config = require(`./aristas/dev.config.js`);
}

if (window.location.hostname === "peluca-79e344313ea6.herokuapp.com") {
  config = require(`./peluca/dev.config.js`);
}

if (window.location.hostname === "manicura-5083fd69e6f3.herokuapp.com") {
  config = require(`./manicura/dev.config.js`);
}

if (window.location.hostname === "mascotas-b555111cf1f4.herokuapp.com") {
  config = require(`./mascotas/dev.config.js`);
}

if (window.location.hostname === "defaultversion-28e6346a27a0.herokuapp.com") {
  config = require(`./default/dev.config.js`);
}

if (window.location.hostname === "binapsis-817ef3db94dd.herokuapp.com") {
  config = require(`./binapsis/dev.config.js`);
}

if (window.location.hostname === "binapsis-software.com") {
  config = require(`./binapsis/dev.config.js`);
}

if (window.location.hostname === "www.binapsis-software.com") {
  config = require(`./binapsis/dev.config.js`);
}

console.log(config.config)
module.exports = config.config;
